<template>
  <!-- <main
    id="regist"
    class="headermargin form__common"
    ref="main"
    :style="{ minHeight: adjustHeight }"
  > -->
  <main id="regist" class="headermargin form__common">
    <section class="livenex--inner">
      <h2>プラン登録完了</h2>
      <p>プラン情報を登録しました。</p>
    </section>
    <section class="cont">
      <div class="livenex--inner">
        <form @submit.prevent="goToMyPage">
          <div class="btn__common">
            <input type="submit" name="Submit" value="マイページへ" class="" />
          </div>
        </form>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  data() {
    return {
      // windowHeight: 0
    };
  },
  created: function() {
    if (this.$route.params.simulationNo == undefined) {
      this.$router.push({ name: "Top" });
    } else {
      this.$store.commit("setScreenLoading", false);
    }
  },
  methods: {
    goToMyPage: function() {
      this.$router.push({ name: "SavedPlanList" });
    }
  }
};
</script>

<style lang="scss"></style>
